import React, { createContext, useContext, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { getCookie } from "../function";

const AuthContext = createContext();


export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(getCookie('token'));


  console.log(token)
  // Decode the JWT and extract user info, such as role
  const decodedToken = token ? jwtDecode(token) : null;
 
  
  const userRole = decodedToken ? decodedToken.user.userType?.toLowerCase() : null; // Assumes JWT contains a "role" claim
  const journalid = decodedToken && decodedToken.user.journal 
 ? JSON.parse(decodedToken.user.journal).includes("2834823r827r") 
    : false;
    // console.log(decodedToken.user.journal)


  const loginUser = (userToken) => {
    setToken(userToken);
    localStorage.setItem('token', userToken);
  };
  
  const logout = () => {
    setToken(null);
    localStorage.removeItem('token');
  };

  const isAuthenticated = !!token;

  return (
    <AuthContext.Provider value={{ isAuthenticated, userRole, journalid , loginUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
